<template>
  <div class="container">
    <header class="tp-content-header">
      <h3>{{ content }}</h3>
    </header>

    <TabView>
      <!-- ========= -->
      <!-- COMMUNITY -->
      <!-- ========= -->
<!--      <TabPanel header="Tipp Gemeinschaft">-->

        <!-- ============================= -->
        <!-- COMMUNITY SEASON SUBSCRIPTION -->
        <!-- ============================= -->

        <!-- Activate new season subscription -->

        <!-- =================== -->
        <!-- COMMUNITY USER LIST -->
        <!-- =================== -->

        <!-- Assign user to new season subscription -->
        <!-- <SeasonUserPickList/> -->

<!--      </TabPanel>-->

      <!-- =============== -->
      <!-- HIGHLIGHT GAMES -->
      <!-- =============== -->
      <TabPanel header="Top Spiele">
        <MatchList></MatchList>
      </TabPanel>

      <!-- =============== -->
      <!-- HIGHLIGHT GAMES -->
      <!-- =============== -->
      <TabPanel header="Saison Gewinne">
        <ProfitList></ProfitList>
      </TabPanel>
    </TabView>

  </div>
</template>

<script>
import UserService from '../services/user.service';
import MatchList from "../components/MatchList";
import ProfitList from "../components/ProfitList";
// import SeasonUserPickList from "@/components/SeasonUserPickList";

export default {
  name: 'Other',
  components: {
    // SeasonUserPickList,
    MatchList,
    ProfitList
  },
  data() {
    return {
      content: ''
    };
  },
  mounted() {
    UserService.getModeratorBoard().then(
        response => {
          this.content = response.data;
        },
        error => {
          if (error.response.status === 401) {
            this.content = "Du bist nicht eingeloggt!";
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
          } else {
            this.content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
          }
        }
    );
  }
};
</script>